<template>
  <div class="case">
    <div class="title">Stack it up</div>
    <base-grid
      :items="completedCourses"
      :imageUrls="imageUrls"
      :showTitle="false"
      style="padding: 5px;"
      v-on:grid:badge:click="
        $router.push({
          name: 'coursesMentor',
          params: { id: $event.id }
        })
      "
    ></base-grid>
  </div>
</template>
<script>
import BaseGrid from "@/components/BaseGrid"
import { mapGetters } from "vuex"

export default {
  components: {
    BaseGrid
  },
  props: {
    userId: { type: Number }
  },
  computed: {
    ...mapGetters("courses", ["getCompletedCoursesByUserId"]),
    completedCourses() {
      return this.getCompletedCoursesByUserId(this.userId)
    },
    imageUrls() {
      return this.completedCourses.map(el => el.badge_url)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

div.title {
  color: $very-dark-grey;
  display: flex;
  font-family: $main-font-family !important;
  font-style: italic;
  font-size: 1em !important;
  justify-content: flex-start;
  margin-left: 25px;
  margin-top: -15px;
  padding-left: 10px;
  position: absolute;
  text-transform: uppercase;
  width: 100%;
}
div.case {
  background-color: $trophy-backgroud;
  border-radius: 25px;
  border-color: $light-grey;
  margin-top: 20px;
  position: relative;
  min-height: 148px;
}
div.v-sheet {
  background-color: $trophy-backgroud;
  border-radius: 25px;
  min-height: 148px;
}
</style>
